import { render, staticRenderFns } from "./HorizontalDetailTitle.vue?vue&type=template&id=17f19a12&scoped=true&"
import script from "./HorizontalDetailTitle.vue?vue&type=script&lang=js&"
export * from "./HorizontalDetailTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f19a12",
  null
  
)

export default component.exports